export const HANDLE_GET_USER_BICYCLES = 'handleGetUserBicycles';

export const HANDLE_SELECTED_BICYCLE = 'handleSelectedBicycle';

export const HANDLE_GET_BICYCLE_TYPES = 'handleGetBicycleTypes';
